import { render, staticRenderFns } from "./CommercialBannerSlider.vue?vue&type=template&id=5cc40121&scoped=true"
import script from "./CommercialBannerSlider.vue?vue&type=script&lang=js"
export * from "./CommercialBannerSlider.vue?vue&type=script&lang=js"
import style0 from "./CommercialBannerSlider.vue?vue&type=style&index=0&id=5cc40121&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc40121",
  null
  
)

export default component.exports